enum Constants {
  Geozones = "Геозоны",
  Geozone = "Геозона",
  Units = "Техники",
  Unit = "Техника",
  
}
export {Constants};